import {
  useFetchInboxQuery,
  useFetchNotifQuery,
  useLazyFetchReadInboxQuery,
  useFetchReadNotifMutation,
  useFetchReadAllNotifMutation,
} from 'features/private-views/dashboard/dashboardApiSlice'
import { useEffect, useState } from 'react'
import { Bell, ChevronRight, Menu } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Navbar,
  NavbarBrand,
  Spinner,
  UncontrolledDropdown,
} from 'reactstrap'
import UserDropdown from './UserDropdown'

import ICPembelian from 'assets/icons/Pembelian.png'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import {
  setDataInbox,
  toggleModalInbox,
  toggleNavbar,
} from 'features/private-views/dashboard/dashboardSlice'
import { setType } from 'features/private-views/notification-inbox/notifInboxSlice'
import { getMetaContent } from 'helpers'
import { useDispatch, useSelector } from 'react-redux'
import { formatDatePMBV2 } from 'utils/formatDate'
import { handleNotificationClick } from 'utils/notificationHelper'
import { URL_NOTIF_INBOX } from 'utils/pathUrl'
import useCompanyLogo from 'hooks/useCompanyLogo'

const NavbarDashboard = (args) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const url = window.location.href
  const [triggerReadInbox] = useLazyFetchReadInboxQuery()
  const [triggerReadNotif] = useFetchReadNotifMutation()
  const [triggerReadAllNotif] = useFetchReadAllNotifMutation()
  const { ownerData } = useSelector((s) => s.dashboard)
  const ownerUserId = ownerData?.userId
  const { logoSrc } = useCompanyLogo()
  const [page, setPage] = useState(0)
  const [pageInbox, setPageInbox] = useState(0)
  const [notifs, setNotifs] = useState([])
  const [inboxes, setInboxes] = useState([])
  const [isEndOfList, setIsEndOfList] = useState(false)
  const [isEndOfListInbox, setIsEndOfListInbox] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isDropdownOpenInbox, setIsDropdownOpenInbox] = useState(false)
  const [activeTab, setActiveTab] = useState('notif')

  const resNotif = useFetchNotifQuery({ page })
  const resInbox = useFetchInboxQuery(
    { page: pageInbox, type: activeTab },
    { skip: activeTab === 'notif' },
  )

  const tabs = [
    { key: 'notif', label: 'Aktivitas' },
    { key: 'general', label: 'Pemberitahuan' },
    { key: 'consent', label: 'Persetujuan' },
  ]

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey)
  }

  useEffect(() => {
    setInboxes([])
    setPageInbox(0)
    setIsEndOfListInbox(false)
  }, [activeTab])

  const handleRead = (id) => {
    if (activeTab === 'notif') {
      triggerReadNotif(id).then(() => {
        if (resNotif && !resNotif.isUninitialized && typeof resNotif.refetch === 'function') {
          resNotif.refetch()
        }
      })
    } else {
      triggerReadInbox(id).then(() => {
        if (resInbox && !resInbox.isUninitialized && typeof resInbox.refetch === 'function') {
          resInbox.refetch()
        }
      })
    }
  }

  useEffect(() => {
    if (resNotif?.status === 'fulfilled' && resNotif?.data?.items) {
      if (resNotif?.data?.items.length === 0) {
        setIsEndOfList(true)
      } else {
        setNotifs(resNotif.data.items.slice(0, 5))
      }
    }
  }, [resNotif])

  useEffect(() => {
    if (resInbox?.status === 'fulfilled' && resInbox?.data?.items) {
      if (resInbox?.data.items.length === 0) {
        setIsEndOfListInbox(true)
      } else {
        setInboxes(resInbox.data.items.slice(0, 5))
      }
    }
  }, [resInbox])

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [dispatch])

  return (
    <>
      <Navbar
        {...args}
        className="border fixed-top bg-white"
        style={{ height: '75px' }}
      >
        <NavbarBrand>
          <div>
            {screenWidth < 768 ? (
              <div className="d-flex align-items-center gap-3">
                <Menu
                  className="pointer"
                  size={24}
                  data-testid="navbar-menu-toggle"
                  onClick={() => dispatch(toggleNavbar())}
                />
                {url?.includes('kursus') ? 'Kursus' : ''}
              </div>
            ) : (
              <div className="d-flex align-items-center gap-3">
                {screenWidth < 1100 && (
                  <Menu
                    className="pointer"
                    size={24}
                    data-testid="navbar-menu-toggle"
                    onClick={() => dispatch(toggleNavbar())}
                  />
                )}
                <div
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => navigate('/')}
                  data-testid="navbar-brand"
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    alt={`${getMetaContent('og:title')} logo`}
                    src={logoSrc}
                    style={{
                      maxWidth: '140px',
                      maxHeight: '36px',
                      height: 'auto',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </NavbarBrand>
        <div className="d-flex justify-content-end">
          <UncontrolledDropdown
            group
            isOpen={isDropdownOpen}
            toggle={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <DropdownToggle
              className="bg-transparent border-0"
              data-testid="navbar-notification-bell"
            >
              <div className="d-flex position-relative">
                <div className="d-flex flex-centered">
                  <Bell size={26} className="text-secondary" />
                  {resNotif?.data?.unreadCount > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px' }}>
                      {resNotif?.data?.unreadCount > 99 ? '99+' : resNotif?.data?.unreadCount}
                    </span>
                  )}
                </div>
              </div>
            </DropdownToggle>
            <DropdownMenu
              className="border-0"
              style={{
                width: screenWidth < 500 ? '320px' : '420px',
                maxHeight: '500px',
                overflowY: 'hidden',
                boxShadow: '0 12px 36px rgba(0,0,0,0.12)',
                borderRadius: '16px',
                padding: 0,
                marginTop: '10px'
              }}
            >
              <div
                className="px-4 py-3 bg-white"
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 2,
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="fw-bold text-dark" style={{ fontSize: '1.1rem' }}>
                    Notifikasi
                  </div>
                  <div 
                    className="text-primary pointer" 
                    style={{ fontSize: '0.9rem', cursor: 'pointer' }}
                    data-testid="navbar-mark-all-read"
                    onClick={() => {
                      triggerReadAllNotif().then(() => {
                        if (resNotif && !resNotif.isUninitialized && typeof resNotif.refetch === 'function') {
                          resNotif.refetch();
                        }
                        if (activeTab !== 'notif' && resInbox && !resInbox.isUninitialized && typeof resInbox.refetch === 'function') {
                          resInbox.refetch();
                        }
                      })
                    }}
                  >
                    Tandai Semua Dibaca
                  </div>
                </div>
                <PMBTabSwitcher
                  activeTab={activeTab}
                  tabs={tabs}
                  onTabChange={handleTabChange}
                  testId="navbar-notif-tab"
                  className="d-flex gap-3"
                />
              </div>

              <div style={{ maxHeight: '300px', overflowY: 'auto', padding: '8px 0' }}>
                {(resNotif?.status === 'pending' && activeTab === 'notif') ||
                  (resInbox?.status === 'pending' && activeTab !== 'notif') ? (
                  <DropdownItem text>
                    <div className="d-flex justify-content-center">
                      <Spinner />
                    </div>
                  </DropdownItem>
                ) : (activeTab === 'notif' ? notifs : inboxes)?.length > 0 ? (
                  (activeTab === 'notif' ? notifs : inboxes)?.map(
                    (e, index) => {
                      const isUnread = !e?.userinboxread && !e?.readAt
                      return (
                        <div
                          key={index}
                          className={`notif-item px-3 py-2 ${isUnread ? 'bg-light' : ''}`}
                          data-testid={`navbar-notif-item-${e?.id ?? index}`}
                          style={{
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease',
                            borderBottom: '1px solid #f8f9fa'
                          }}
                          onMouseOver={(evt) => evt.currentTarget.style.backgroundColor = '#f8f9fa'}
                          onMouseOut={(evt) => evt.currentTarget.style.backgroundColor = isUnread ? '#f8f9fa' : 'transparent'}
                          onClick={() => {
                            if (isUnread) {
                              handleRead(e.id);
                            }
                            const navigated = handleNotificationClick(
                              e,
                              navigate,
                              ownerUserId,
                              dispatch,
                              null,
                            )
                            if (!navigated) {
                              dispatch(toggleModalInbox())
                              dispatch(setDataInbox(e))
                            }
                            setIsDropdownOpen(false)
                          }}
                        >
                          <div className="d-flex flex-column gap-2">
                            <div className="d-flex align-items-center gap-2">
                              <img
                                style={{ width: '22px', height: '22px', objectFit: 'contain' }}
                                alt="foto"
                                src={ICPembelian}
                              />
                              <span className="text-secondary" style={{ fontSize: '12px' }}>
                                {formatDatePMBV2(e?.createdAt ?? e?.scheduledTime)}
                              </span>
                            </div>

                            <div className="px-1">
                              <div className={`fw-bold mb-1 ${isUnread ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '14px' }}>
                                {e?.title}
                                {isUnread && (
                                  <span className="ms-2 rounded-circle bg-danger d-inline-block" style={{ width: '8px', height: '8px' }}></span>
                                )}
                              </div>
                              <div
                                className="text-muted text-truncate d-block"
                                style={{
                                  fontSize: '13px',
                                  maxWidth: screenWidth < 500 ? '260px' : '360px',
                                  }}
                              >
                                {e?.message}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    },
                  )
                ) : (
                  <DropdownItem data-testid="navbar-notif-empty">
                    <small>Tidak ada notifikasi</small>
                  </DropdownItem>
                )}
              </div>

              {((activeTab === 'notif' && resNotif?.status !== 'pending') ||
                (activeTab !== 'notif' && resInbox?.status !== 'pending')) && (
                  <div
                    style={{
                      background: 'white',
                      borderTop: '1px solid #f8f9fa',
                      borderBottomLeftRadius: '16px',
                      borderBottomRightRadius: '16px',
                    }}
                  >
                    <div
                      className="text-primary text-center fw-bold py-3 pointer"
                      style={{ fontSize: '14px', transition: 'background-color 0.2s', borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}
                      data-testid="navbar-view-all-notifications"
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      onClick={() => {
                        setIsDropdownOpen(false)
                        if (activeTab === 'notif') {
                          navigate(URL_NOTIF_INBOX)
                          dispatch(setType('notif'))
                        } else if (activeTab === 'general') {
                          navigate(URL_NOTIF_INBOX)
                          dispatch(setType('general'))
                        } else {
                          navigate(URL_NOTIF_INBOX)
                          dispatch(setType('consent'))
                        }
                      }}
                    >
                      Lihat Semua Notifikasi <ChevronRight size={16} className="ms-1" style={{ marginBottom: '2px' }} />
                    </div>
                  </div>
                )}
            </DropdownMenu>
          </UncontrolledDropdown>

          <UserDropdown profile={args.profile} />
        </div>
      </Navbar>
    </>
  )
}

export default NavbarDashboard
